<template>
  <div class="form-group" :class="{ error: $zodValidator.errors.has(name) }">
    <label v-if="label" :for="name">{{ label }}</label>
    <MaskedInput
      v-if="type == 'tel'"
      class="form-control"
      type="text"
      mask="(111) 111-1111"
      :disabled="disabled"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      @input="setValidatorValue"
      v-zvalidate="validation"
    >
    </MaskedInput>
    <input
      v-else
      class="form-control"
      :disabled="disabled"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      v-zvalidate="validation"
      @input="$emit('input', $event.target.value)"
      @focus="focus"
      @blur="blur"
    />
    <div class="error" v-show="$zodValidator.errors.has(name)">
      {{ errorField($zodValidator.errors.first(name)) }}
    </div>
  </div>
</template>
<script lang="ts">
import MaskedInput from 'vue-masked-input'
export default {
  components: { MaskedInput },
  props: {
    label: null,
    placeholder: null,
    disabled: Boolean,
    value: {
      default: '',
      type: String,
      required: false,
    },
    name: {
      default: '',
      type: String,
      required: false,
    },
    scope: {
      default: '',
      type: String,
      required: false,
    },
    type: {
      default: 'text',
      type: String,
      required: false,
    },
    validation: {
      default: null,
      type: Object,
    },
  },
  computed: {
    theLabel() {
      return this.label || this.placeholder || 'Enter value'
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value)
    },
  },
  methods: {
    errorField(field) {
      if (field) return field.split('_').join(' ')
    },
    blur() {
      this.$emit('text_input:blur')
    },
    focus() {
      this.$emit('text_input:focus')
    },
    setValidatorValue(value: string, raw: string) {
      this.$zodValidator.setValue(this.name, raw.replace(/_/g, ''))
      this.$emit('input', value)
    },
  },
}
</script>
<style lang="sass" scoped>
label
  font-size: 14px
  margin: 0 0 4px 0
  padding: 0
</style>
